import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useDatasetPathDestination } from "@/composables/datasetPathDestination";
import { getAppRoot } from "@/onload/loadConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetAsImage',
    props: {
        historyDatasetId: null,
        path: null
    },
    setup(__props) {
        const props = __props;
        const { datasetPathDestination } = useDatasetPathDestination();
        const pathDestination = computed(() => datasetPathDestination.value(props.historyDatasetId, props.path));
        const imageUrl = computed(() => {
            var _a;
            if (props.path === undefined || props.path === "undefined") {
                return `${getAppRoot()}dataset/display?dataset_id=${props.historyDatasetId}`;
            }
            return (_a = pathDestination.value) === null || _a === void 0 ? void 0 : _a.fileLink;
        });
        return { __sfc: true, datasetPathDestination, props, pathDestination, imageUrl };
    }
});
